import type { ReactNode } from 'react'
import React from 'react'
import { Tooltip } from 'react-bootstrap'
import { Icon, TooltipPopOver } from '@ztechapps/webui.util'
import type { InventoryBySerialNumber } from '@ztechapps/common.contract'
import isEmpty from 'lodash/isEmpty'

export const SerialNumberTooltip = ({
  inventoryBySerialNumbers,
  children,
}: {
  inventoryBySerialNumbers: InventoryBySerialNumber[]
  children?: ReactNode
}) => {
  const hasSerialNumbers = !isEmpty(inventoryBySerialNumbers)

  const infoTitle = hasSerialNumbers
    ? `Serial Numbers : ${(inventoryBySerialNumbers ?? []).map((e) => e.code).join(', ')}`
    : 'Choose serial numbers for this product.'

  children = children ?? <Icon name="qrcode" />

  return (
    <TooltipPopOver overlay={<Tooltip>{infoTitle}</Tooltip>}>
      <div className={hasSerialNumbers ? 'text-success' : 'text-warning'}>{children}</div>
    </TooltipPopOver>
  )
}
